import React from 'react';
import { IconProps } from './types';

const ReportsIcon: React.FC<IconProps> = props => {
  const { height = 16, width = 16, fillColor = 'var(--text-primary)' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.75494 2.13281H3.81125C3.73096 2.13281 3.66406 2.19971 3.66406 2.28V13.8875C3.66406 13.9678 3.73096 14.0347 3.81125 14.0347H12.2275C12.3078 14.0347 12.3747 13.9678 12.3747 13.8875V2.28669C12.3747 2.2064 12.3078 2.1395 12.2275 2.1395H6.75494V2.13281Z"
        stroke={fillColor}
        strokeWidth="0.8"
        strokeMiterlimit="10"
      />
      <path
        d="M5.32935 5.9375H10.6627"
        stroke={fillColor}
        strokeWidth="0.666667"
        strokeMiterlimit="10"
      />
      <path
        d="M5.29553 8.00781H10.6289"
        stroke={fillColor}
        strokeWidth="0.666667"
        strokeMiterlimit="10"
      />
      <path
        d="M5.32935 10.0078H8.99601"
        stroke={fillColor}
        strokeWidth="0.666667"
        strokeMiterlimit="10"
      />
      <path
        d="M9.89396 2.06629H8.99748C8.87705 1.6515 8.49571 1.34375 8.04078 1.34375C7.58584 1.34375 7.2045 1.6515 7.08408 2.06629H6.18759C6.10731 2.06629 6.04041 2.13319 6.04041 2.21348V2.58144C6.04041 3.1501 6.50203 3.61173 7.0707 3.61173H9.00416C9.57283 3.61173 10.0345 3.1501 10.0345 2.58144V2.21348C10.0345 2.13319 9.96755 2.06629 9.88727 2.06629H9.89396Z"
        fill="#001833"
        stroke={fillColor}
        strokeWidth="0.666667"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default ReportsIcon;
